<template lang="pug">
  div
    b-alert(:show='dismissCountDown' dismissible='' :variant='tipo' @dismissed='dismissCountDown=0' @dismiss-count-down='countDownChanged')
      | {{ mensaje }}
</template>

<script>

export default {
  name: "notificacion",
  data() {
    return {
      mensaje: '',
      tipo:'',
      dismissSecs: 10,
      dismissCountDown: 0
    }
  },
  methods: {
    notificar(mensaje,tipo) {
      this.dismissCountDown = this.dismissSecs
      this.mensaje=mensaje;
      this.tipo=tipo;
    },

    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
  }
}
</script>
